import { render, staticRenderFns } from "./LKMunMehFormDocumentsFooter.vue?vue&type=template&id=e852f66c&scoped=true&"
import script from "./LKMunMehFormDocumentsFooter.vue?vue&type=script&lang=js&"
export * from "./LKMunMehFormDocumentsFooter.vue?vue&type=script&lang=js&"
import style0 from "./LKMunMehFormDocumentsFooter.vue?vue&type=style&index=0&id=e852f66c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e852f66c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCheckbox,VLayout,VSpacer})
